<template>
  <div>
    <Header
      :seller-logo-url="sellerLogoUrl"
      :hide-search="true"
      :logged-in="loggedIn"
      :hide-buyer-id-on-mobile="true"
      :show-category-trigger="false"
    />
    <main class="cart-show">
      <router-link to="/">
        <button id="back-to-main" class="btn btn-tertiary" style="margin-bottom: 3rem;">
          <i class="fas fa-chevron-left" />&nbsp;
          Back to Shopping
        </button>
      </router-link>

      <div class="cart-viewer-container">
        <div>
          <h1>View Cart ({{ totalItems }} items)</h1>
          <table style="width: 100%" class="table">
            <tr v-for="product in products" :key="product.id">
              <td>
                <img class="product-img-small" :src="product.image_url">
              </td>
              <td width="70%">
                <div class="product-name">
                  {{ product.name }}
                  <span v-if="product.price_on_sale" class="on-sale">
                    <i class="fa-solid fa-badge-dollar" />
                    On sale
                  </span>
                </div>
              </td>
              <td>
                <input
                  :ref="`quantity-input-${product.id}`"
                  type="number"
                  class="quantity-input"
                  max="999"
                  :value="product.quantity"
                  @input="updateQuantity(product.id)"
                >
              </td>
              <td>
                <div class="line-total">
                  {{ product.total_dollars }}
                </div>
                <div class="unit-total">
                  {{ product.price_dollars }} per unit
                </div>
              </td>
              <td @click="deleteProduct(product.id)">
                <a class="remove-product-cart">
                  <i class="far fa-times" />
                </a>
              </td>
            </tr>
          </table>
        </div>

        <div>
          <h1>Total</h1>
          <div class="total-box">
            <p class="gross">
              {{ grossPrice }}
            </p>
            <p v-if="gstEnabled" class="gst">
              including GST {{ gstPrice }}
            </p>
          </div>

          <router-link id="checkout" to="/checkout">
            <button class="btn block-btn">
              <i class="fas fa-shopping-cart" /> &nbsp;
              Proceed to Checkout
            </button>
          </router-link>
        </div>
      </div>
    </main>
  </div>
</template>
<script>
import Header from '../header.vue';
import debounce from '../../../debounce';
export default {
  components: {Header},
  props: {
    sellerLogoUrl: { type: String, required: true },
    loggedIn: { type: Boolean, required: true },
  },
  computed: {
    sellerPid: function() {
      return this.$store.state.sellerPid;
    },
    gstPrice: function() {
      return this.$store.state.productsGstPrice;
    },
    grossPrice: function() {
      return this.$store.state.productsGrossPrice;
    },
    products: function() {
      return this.$store.state.products;
    },
    cartPid: function() {
      return this.$store.state.cartId;
    },
    totalItems: function() {
      return this.$store.getters.cartTotal;
    },
    gstEnabled: function() {
      return this.$store.state.gstEnabled;
    },
  },
  mounted: function() {
    if (!this.$store.state.cartId) {
      this.$router.push({ path: '/' });
    }
  },
  methods: {
    deleteProduct: function(productId) {
      this.$store.dispatch('removeProduct', { productId: productId, sellerPid: this.sellerPid});
    },
    updateQuantity: debounce(function (id) {
      let newQuantity = this.$refs[`quantity-input-${id}`][0].value;
      if (!newQuantity || newQuantity < 1) {
        newQuantity = 1;
        this.$refs[`quantity-input-${id}`][0].value = 1;
      }
      if (newQuantity > 999) {
        newQuantity = 999;
        this.$refs[`quantity-input-${id}`][0].value = 999;
      }
      this.$store.dispatch('updateProductQuantity', {id: id, newQuantity: newQuantity, sellerPid: this.sellerPid});
    }, 300),
  },
};
</script>
